"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var recaptcha_1 = require("~/util/recaptcha");
var RECAPTCHA_ERROR_MESSAGE = 'reCAPTCHA認証に失敗しました。もう一度やり直してください';
var RecaptchaFormController = /** @class */ (function (_super) {
    __extends(RecaptchaFormController, _super);
    function RecaptchaFormController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isSubmitting = false;
        _this.connect = function () {
            _this.siteKey = _this.data.get('site-key') || '';
            if (!_this.siteKey)
                return;
            (0, recaptcha_1.loadRecaptchaScript)(_this.siteKey).catch(function (error) {
                console.error('Failed to preload reCAPTCHA script:', error);
            });
        };
        _this.submit = function (event) { return __awaiter(_this, void 0, Promise, function () {
            var submitButton, token, form, formData, response, contentType, data, e_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.siteKey)
                            return [2 /*return*/];
                        if (this.isSubmitting) {
                            event.preventDefault();
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        this.isSubmitting = true;
                        submitButton = this.getSubmitButton();
                        if (submitButton)
                            submitButton.disabled = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 9, , 10]);
                        return [4 /*yield*/, (0, recaptcha_1.executeRecaptcha)(this.siteKey, 'submit_contact_form')];
                    case 2:
                        token = _a.sent();
                        if (!token || typeof token !== 'string')
                            throw new Error('Missing reCAPTCHA token');
                        form = this.element;
                        formData = new FormData(form);
                        formData.append('recaptcha_token', token);
                        return [4 /*yield*/, fetch(form.action, {
                                method: (form.getAttribute('method') || 'POST').toUpperCase(),
                                body: formData,
                                headers: { 'Accept': 'text/html' },
                                redirect: 'follow',
                                credentials: 'same-origin'
                            })];
                    case 3:
                        response = _a.sent();
                        contentType = response.headers.get('content-type') || '';
                        if (!(!response.ok && contentType.includes('application/json'))) return [3 /*break*/, 8];
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, response.json()];
                    case 5:
                        data = _a.sent();
                        alert(data.message || RECAPTCHA_ERROR_MESSAGE);
                        return [3 /*break*/, 7];
                    case 6:
                        e_1 = _a.sent();
                        alert(RECAPTCHA_ERROR_MESSAGE);
                        return [3 /*break*/, 7];
                    case 7:
                        if (submitButton)
                            submitButton.disabled = false;
                        this.isSubmitting = false;
                        return [2 /*return*/];
                    case 8:
                        if (response.redirected) {
                            window.location.href = response.url;
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 10];
                    case 9:
                        error_1 = _a.sent();
                        console.error('Failed to get reCAPTCHA token:', error_1);
                        alert(RECAPTCHA_ERROR_MESSAGE);
                        if (submitButton)
                            submitButton.disabled = false;
                        this.isSubmitting = false;
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    RecaptchaFormController.prototype.getSubmitButton = function () {
        var form = this.element;
        return form.querySelector('[type="submit"]');
    };
    return RecaptchaFormController;
}(stimulus_1.Controller));
exports.default = RecaptchaFormController;
